exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-menu-horizontal[data-v-30ed70fa] {\n  border-bottom: 1px solid #e5e5e5;\n}\n.sau-menu-horizontal ul li[data-v-30ed70fa] {\n  display: inline-block;\n}\n", ""]);

// exports
